import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/global-error.tsx");
